import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapVoid } from '../ruutsApi/normalize'

// DELETE answers { payload: { success, key } } but nothing here needs it (playbook 2.6).
export const deleteFile = async ({ key }: { key: string }) => {
  const response = await apiClient.delete(`${endpoints.objectStore}/${encodeURIComponent(key)}`)
  return unwrapVoid(response)
}
